import { i, s, x } from '../../lit-element.js';
import { reset } from '../../styles/reset.style.js';

const style = i`
  :host {
    display: none;
    font-size: 1em;
    min-height: 3em;
  }

  :host([active]) {
    display: block;
  }

  div {
    align-items: center;
    background-color: #141414;
    box-sizing: border-box;
    color: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    min-height: 3em;
    padding: 0.75em 1em;
    width: 100%;
  }

  div:not(.global) {
    border-bottom-right-radius: 2px;
    border-top-right-radius: 2px;
    color: #141414;
  }

  p {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    text-align: left;
  }

  p::before {
    content: url("data:image/svg+xml,%3Csvg width='24' height='21' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M23.538 17.488L13.86 1.208c-1.023-1.61-2.697-1.61-3.72 0L.462 17.488c-1.024 1.61-.288 3.047 1.634 3.047h19.808c1.921 0 2.658-1.436 1.634-3.047zM11.923 6.66a.943.943 0 0 1 1.014 1.004l-.444 5.94a.5.5 0 0 1-.537.458.499.499 0 0 1-.463-.458l-.444-5.94a.94.94 0 0 1 .874-1.004zm.07 11.028a1.12 1.12 0 0 1-1.125-1.114 1.12 1.12 0 0 1 1.125-1.114 1.12 1.12 0 0 1 1.125 1.114 1.12 1.12 0 0 1-1.125 1.114z' fill='%23F9C606' fill-rule='evenodd'/%3E%3C/svg%3E");
    height: 1.5em;
    padding-right: 1em;
    width: 1.5em;
  }

  @media (min-width: 48em) {
    .global p {
      text-align: center;
    }
  }

  slot::slotted(a) {
    color: #fff;
    text-decoration: underline;
  }

  div:not(.global) slot::slotted(a) {
    color: #141414;
  }

  .information,
  .informational {
    background: #c0e7f3;
    border-left: 4px solid #255f82;
  }

  .information p::before,
  .informational p::before {
    content: url("data:image/svg+xml,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm1.657 16.938C12.869 17.958 11.085 19 10.274 19c-.37 0-.81-.487-.81-.788 0-.186.068-.556.207-.903.14-.301 1.46-4.031 2.04-5.793.162-.486.046-.625-.07-.625-.44 0-1.46.787-1.854 1.181-.094.093-.37-.278-.37-.394 0-.116.115-.301.207-.463.858-1.228 2.481-2.293 3.64-2.293.3 0 .648.463.648.949 0 .255-.092.557-.186.881l-2.039 5.861c-.022.047.047.21.139.21.3 0 1.181-.534 1.622-.882.185-.138.393-.232.487-.232.093 0 .186.047.186.232 0 .348-.21.672-.464.997zm.347-10.288c-.163.14-.44.21-.694.21-.464 0-1.044-.348-1.044-1.02 0-.602.44-1.136.65-1.298.138-.092.439-.185.624-.185.811 0 1.044.718 1.044 1.042 0 .51-.395 1.113-.58 1.251z' fill='%23255F82' fill-rule='evenodd'/%3E%3C/svg%3E");
  }

  .warning {
    background: #fff1d0;
    border-left: 4px solid #f9c606;
  }

  .warning p::before {
    content: url("data:image/svg+xml,%3Csvg width='24' height='21' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M23.538 17.488L13.86 1.208c-1.023-1.61-2.697-1.61-3.72 0L.462 17.488c-1.024 1.61-.288 3.047 1.634 3.047h19.808c1.921 0 2.658-1.436 1.634-3.047zM11.923 6.66a.943.943 0 0 1 1.014 1.004l-.444 5.94a.5.5 0 0 1-.537.458.499.499 0 0 1-.463-.458l-.444-5.94a.94.94 0 0 1 .874-1.004zm.07 11.028a1.12 1.12 0 0 1-1.125-1.114 1.12 1.12 0 0 1 1.125-1.114 1.12 1.12 0 0 1 1.125 1.114 1.12 1.12 0 0 1-1.125 1.114z' fill='%23141414' fill-rule='evenodd'/%3E%3C/svg%3E");
  }

  .success {
    background: #dae8d8;
    border-left: 4px solid #008140;
  }

  .success p::before {
    content: url("data:image/svg+xml,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 0C5.373 0 0 5.372 0 12s5.373 12 12 12 12-5.372 12-12S18.627 0 12 0zm5.78 8.432l-7 8.06a.757.757 0 0 1-.54.258h-.026a.752.752 0 0 1-.53-.22l-3-3a.75.75 0 1 1 1.06-1.06l2.43 2.43 6.473-7.453a.75.75 0 0 1 1.133.985z' fill='%23008140' fill-rule='evenodd'/%3E%3C/svg%3E");
  }

  .error {
    background: #fcd5d1;
    border-left: 4px solid #cc2427;
  }

  .error p::before {
    content: url("data:image/svg+xml,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12c6.627 0 12-5.372 12-12S18.627 0 12 0zm5.53 16.47a.75.75 0 1 1-1.061 1.06L12 13.06l-4.47 4.47a.747.747 0 0 1-1.06 0 .75.75 0 0 1 0-1.06L10.938 12l-4.47-4.47A.75.75 0 0 1 7.53 6.47L12 10.94l4.469-4.47a.75.75 0 0 1 1.06 1.06L13.06 12l4.47 4.47z' fill='%23CC2427' fill-rule='evenodd'/%3E%3C/svg%3E");
  }

  button {
    background: none;
    border: none;
    color: #404040;
    height: auto;
    min-width: unset;
    padding: 0;
    width: auto;
  }

  button:hover,
  button:focus {
    color: #141414;
    text-decoration: underline;
  }

  .global button {
    color: #fff;
  }

  .global button:hover,
  .global button:focus {
    color: #fff;
    text-decoration: underline;
  }
`;

class RefiAlert extends s {
  constructor() {
    super();
    this.alertType = 'global';
    this.showClose = true;
  }

  static get properties() {
    return {
      showClose: { type: Boolean, attribute: 'show-close', reflect: true },
      active: { type: Boolean, attribute: true, reflect: true },
      alertType: {
        type: String,
        attribute: 'alert-type',
        reflect: true,
        converter: value => {
          switch (value) {
            case 'informational':
            case 'information':
            case 'warning':
            case 'success':
            case 'error':
              return value;
            default:
              return 'global';
          }
        },
      },
    };
  }

  static get styles() {
    return [reset, style];
  }

  render() {
    return x`
      <div class="${this.alertType}">
        <p><slot></slot></p>
        <button ?hidden="${!this.showClose}" type="button" @click="${this.closeAlert}">Close</button>
      </div>
    `;
  }

  closeAlert() {
    this.active = false;
    this.dispatchEvent(new CustomEvent('refiAlertClose'));
  }
}

export { RefiAlert };
